<template>
  <div class="c-post">
    <div class="c-msg" v-html="formatMsg(post.content.main)"></div>
    <v-data-table v-if="cms" :items="sortedDates" class="elevation-3 c-tbl" hide-actions>
      <template v-slot:headers="props">
        <tr class="c-header">
          <th class="c-d">{{ $T('attributes.date') }}</th>
          <th class="c-i"><v-icon>mdi-circle-outline</v-icon></th>
          <th class="c-i"><v-icon>mdi-triangle-outline</v-icon></th>
          <th class="c-i"><v-icon>mdi-window-close</v-icon></th>
          <th class="c-s"><cmid-avatar :cmid="cidToCmid(cid)" :cid="cid" :cms="cms" :size="18" /></th>
        </tr>
      </template>
      <template v-slot:items="d">
        <tr>
          <td class="c-d text-xs-left">
            <v-tooltip top>
              <span slot="activator">{{ fmtDate(d.item) }}</span>
              {{ d.item }}
            </v-tooltip>
          </td>
          <th class="c-i text-xs-center" @click="showList(d.item, 1)">{{ calcCount(d.item, 1) }}</th>
          <th class="c-i text-xs-center" @click="showList(d.item, 2)">{{ calcCount(d.item, 2) }}</th>
          <th class="c-i text-xs-center" @click="showList(d.item, 3)">{{ calcCount(d.item, 3) }}</th>
          <th class="c-s">
            <schedule-selector
              v-model="data.ans[d.item]"
              :readonly="noAnswer"
              :disabled="isGuest || isExpired"
              box
              label="Box style"
            />
          </th>
        </tr>
      </template>
    </v-data-table>
    <div class="c-sample">
      <div><v-icon>mdi-circle-outline</v-icon> {{ toStatus(1) }}</div>
      <div><v-icon>mdi-triangle-outline</v-icon> {{ toStatus(2) }}</div>
      <div><v-icon>mdi-window-close</v-icon> {{ toStatus(3) }}</div>
      <div><v-icon>mdi-minus</v-icon> {{ toStatus(0) }}</div>
    </div>

    <div>
      <v-text-field
        counter="1000"
        data-vv-name="comment"
        v-validate="'max:1000'"
        :error-messages="getMessage('comment')"
        v-model="data.comment"
        color="clr-primary"
        name="comment"
        ref="comment"
        :disabled="isGuest || noAnswer"
        :label="$T('attributes.comment')"
      ></v-text-field>
    </div>

    <div class="c-btn" v-if="!isExpired">
      <v-btn
        v-if="!noAnswer"
        :loading="loading"
        :disabled="isGuest || loading"
        class="c-confirm-btn elevation-6"
        @click="onClicked"
        color="clr-btn"
        round
        dark
        depressed
      >
        <span>{{ $T('common.answer') }}</span>
      </v-btn>
      <v-btn v-else-if="canAnswer" :disabled="isGuest" flat color="clr-primary" @click="doAnswer = true"
        ><v-icon left>mdi-pencil</v-icon>{{ $T('post.re-answer') }}</v-btn
      >
    </div>
    <div v-else class="btn-spc"></div>

    <div class="c-result">
      <div class="c-flex w100 ac">
        <div class="c-result-title s">{{ $T('common.comments') }}</div>
        <div v-if="!isGuest && !isExpired">
          <v-btn flat icon color="clr-black" :loading="answerLoading" @click="loadAnswer(post)">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </div>
      </div>
      <template v-if="answers && cms">
        <div v-if="comments.length == 0">{{ $T('common.no_data') }}</div>
        <v-list v-else class="c-list">
          <template v-for="(item, index) in comments">
            <v-divider />
            <comment-tile :cmid="item.cmid" :cid="cid" :cms="cms" :c="toAnswer(item)" :t="item.answered_at" />
          </template>
          <v-divider />
        </v-list>
      </template>
    </div>

    <cm-list
      v-if="cms && cmids"
      v-model="listDialog"
      :cIcon="false"
      :cms="cms"
      :cid="cid"
      :cmids="cmids"
      :userCmid="cidToCmid(cid)"
    />
  </div>
</template>

<script>
import { CONST } from '../../constant';
import postDetailPlugin from '../../utils/plugin/postDetailPlugin';
import { answerPostSchedule } from '../../api/post';
import scheduleSelector from './ScheduleSelector';

export default {
  mixins: [postDetailPlugin],
  components: {
    'schedule-selector': scheduleSelector,
  },
  data() {
    return {
      loading: false,
      data: {
        ans: {},
        comment: null,
      },
      doAnswer: false,
      cmids: null,
      listDialog: false,
    };
  },
  mounted() {
    this.loadAnswer(this.post);
  },
  watch: {
    post(n, o) {
      this.answeres = null;
      this.doAnswer = false;
      this.loadAnswer(n);
    },
    selfAnswer(n, o) {
      if (!n) return;
      var d = this.data;
      for (var k of Object.keys(n.answer.a)) d.ans[k] = n.answer.a[k];
      d.comment = n.answer.c;
    },
  },
  computed: {
    comments() {
      var as = this.answers;
      if (!as || as.length == 0) return [];

      as = as.filter(data => {
        return !!data.answer.c;
      });
      as.sort(function(a, b) {
        return a.answered_at == b.answered_at ? (a.cmid < b.cmid ? -1 : 1) : a.answered_at < b.answered_at ? 1 : -1;
      });
      return as;
    },
    sortedDates() {
      var ds = this.post.content.dates.concat();
      ds.sort();
      return ds;
    },
    noAnswer() {
      return !this.canAnswer || (this.isAnswered && !this.doAnswer);
    },
  },
  methods: {
    toStatus(status) {
      return CONST.postScheduleStatus[status];
    },
    toAnswer(item) {
      return item.answer.c;
    },
    fmtDate(d) {
      var f = this.isUsFormat ? 'common.moment.us.mdw' : 'common.moment.mdw';
      var m = this.$moment(d);
      var s = m.format($T(f));
      // 候補キーが yyyy-MM-dd'T'HH:mm（時刻付き）なら時刻も表示。日付のみキーは従来どおり。
      var hasTime = typeof d === 'string' && d.length >= 13 && d.charAt(10) === 'T';
      return hasTime ? s + ' ' + m.format('HH:mm') : s;
    },
    fmtTime(item) {
      return this.diffDateFormatShort(this.$moment.unix(item.answered_at));
    },
    onClicked() {
      this.loading = true;
      var self = this;
      this.$validator.validateAll().then(result => {
        if (!result) return (self.loading = false);
        self.postData();
      });
    },
    postData() {
      if (this.isGuest) return;

      var d = this.data;
      var data = new FormData();

      var ans = [];
      for (var k of Object.keys(d.ans)) ans.push(`${k} ${d.ans[k]}`);

      data.append('pid', this.post.id);
      data.append('ans', ans);
      data.append('comment', cnvl(d.comment, ''));

      var self = this;
      answerPostSchedule(data)
        .then(function(post) {
          self.$emit('modified', post);
          self.post = post;
          self.doAnswer = false;
          self.loadAnswer(post);
          self.loading = false;
        })
        .catch(function(e) {
          console.error('failed to answer post data for pid[' + self.post.id + ']', e);
          self.errRegisterData();
          self.loading = false;
        });
    },
    calcCount(d, status) {
      var as = this.answers;
      if (!as || as.length == 0) return '-';
      var c = 0;
      for (var a of as) if (a.answer.a[d] == status) c++;
      return c;
    },
    showList(d, status) {
      var as = this.answers;
      if (!as || as.length == 0) return;
      var cmids = [];
      for (var a of as) if (a.answer.a[d] == status) cmids.push(a.cmid);
      this.cmids = cmids;
      this.listDialog = true;
    },
  },
};
</script>

<style scoped>
.c-post {
  padding-bottom: 20px;
}
.c-tbl {
  margin-top: 5px;
}
.c-tbl i {
  font-size: 18px;
}
.c-header {
  height: 44px !important;
}
.c-d {
  padding: 12px 0 12px 16px !important;
}
.c-header .c-d {
  padding: 12px 0 !important;
}
.c-i {
  padding: 12px 4px !important;
}
.c-header .c-i {
  padding: 0px 4px !important;
  color: #000;
}
.c-s {
  padding: 0 12px 0 12px !important;
  width: 100px;
}
.le-sp .c-s {
  width: 72px;
}
.c-header .c-s {
  padding: 0px 12px 0px 12px !important;
}

.c-sample {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
  margin: 5px 0 15px 10px;
}
.c-sample i {
  transform: translateY(2px);
  font-size: 18px;
}

.c-confirm-btn {
  min-width: 200px;
}
.c-btn {
  text-align: center;
  padding: 15px 0 30px 0;
}
.btn-spc {
  height: 35px;
}
.le-tbs .c-btn {
  padding: 15px 0 30px 0;
}

.c-result-title {
  font-weight: 600;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
  font-size: 16px;
}
.c-list {
  overflow-x: hidden;
}
</style>
